import script from "./FooterBlue.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBlue.vue?vue&type=script&setup=true&lang=js"

import "./FooterBlue.vue?vue&type=style&index=0&id=2ad542c9&lang=scss"

const __exports__ = script;

export default __exports__